import { z } from 'zod'
import { createdAtSortQueryShape, creatorListQueryShape } from '../list-query/contract.ts'
import { accountDisplaySchema } from '../profile/contract.ts'

export const DEFAULT_TAG_COLOR = '#34ba9e'

export const tagColorSchema = z
  .string()
  .trim()
  .regex(/^#[\da-f]{6}$/i, '标签颜色格式不正确')

export const tagUpsertSchema = z.object({
  name: z.string().trim().min(1, '标签名称不能为空').max(100),
  color: tagColorSchema.default(DEFAULT_TAG_COLOR)
})

export const tagOptionSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  color: tagColorSchema
})

export const tagUpsertRequestSchema = z.object({
  id: z.number().int().positive().optional(),
  data: tagUpsertSchema
})

export const tagRemoveSchema = z.object({ id: z.number().int().positive() })
export const tagIdsSchema = z
  .array(z.number().int().positive())
  .min(1, '至少选择一个标签')
  .max(100, '单次最多处理 100 个标签')
export const tagBatchRemoveSchema = z.object({ ids: tagIdsSchema })

export const tagListSchema = z.object({
  current: z.number().int().min(1).default(1),
  pageSize: z.number().int().min(1).max(100).default(20),
  id: z.number().int().positive().optional(),
  keyword: z.string().trim().max(100).optional(),
  ...creatorListQueryShape,
  ...createdAtSortQueryShape
})

export const tagSchema = tagOptionSchema.extend({
  creator: accountDisplaySchema,
  createdAt: z.date(),
  updatedAt: z.date()
})

export const tagListOutputSchema = z.object({
  data: z.array(tagSchema),
  total: z.number().int().nonnegative(),
  current: z.number().int().positive(),
  pageSize: z.number().int().positive()
})

export const tagOptionsInputSchema = z
  .union([
    z.string().trim().max(100),
    z.object({
      keyword: z.string().trim().max(100).optional(),
      selectedIds: z.array(z.number().int().positive()).max(50).optional()
    })
  ])
  .optional()
export type TagOptionsInput = z.infer<typeof tagOptionsInputSchema>

export type TagListInput = z.infer<typeof tagListSchema>
export type TagUpsertInput = z.input<typeof tagUpsertSchema>
export type TagRemoveInput = z.infer<typeof tagRemoveSchema>
export type TagBatchRemoveInput = z.infer<typeof tagBatchRemoveSchema>
